import React, { useState, useEffect } from 'react';
import { RotateSpinner } from 'react-spinners-kit';
import * as clipboard from 'clipboard-polyfill';
import { motion } from 'framer-motion';
import { logCustomEvent } from './UtilAnalytics';

const PathProductBusinessTransformation = ({ businessAnalysisData, storySpeakerSummaryResult, producedResult, salesAnalysisData, businessTransformationResult, generateStoryBite, handlePrint }) => {
    // console.log('PRODUCED RESULT ///////')
    // console.log(producedResult);
    // console.log('PRODUCED RESULT ///////')

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [storyBite, setStoryBite] = useState(null);
    const [storyBiteCategory, setStoryBiteCategory] = useState(null);
    const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
    const [isTableCopied, setIsTableCopied] = useState(false);




    const handleGenerateStoryBite = async (item) => {
        setStoryBiteCategory(item.category);
        setIsLoading(true);
        setIsModalOpen(true);

        try {
            const result = await generateStoryBite(item);
            setStoryBite(result);

        } catch (error) {
            console.error("Error generating StoryBite:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const copyToClipboard = () => {
        if (storyBite?.data?.shortStory) {
            navigator.clipboard.writeText(storyBite.data.shortStory);
        }
    };

    const handleCopy = (item) => {
        const htmlContent = `
            <div>
                <p><b>Current State</b></p>
                <p>${item.from}</p>
                <p><b>Future State</b></p>
                <p>${item.to}</p>
                <p><b>Impact</b></p>
                <p>${item.impact}</p>
            </div>
        `;
        
        // Use clipboard.writeText for simple text copying
        clipboard.writeText(`Current State\n${item.from}\n\nFuture State\n${item.to}\n\nImpact\n${item.impact}`);
        
        // For HTML copying, check your clipboard-polyfill version
        // Modern version (v3+)
        if (clipboard.write) {
            const blob = new Blob([htmlContent], {type: 'text/html'});
            const data = [new ClipboardItem({'text/html': blob})];
            clipboard.write(data).catch(err => console.error('Clipboard write failed:', err));
        }
    };

    // Effect to reset the copy icon after a delay
    useEffect(() => {
        if (isTableCopied) {
            const timer = setTimeout(() => {
                setIsTableCopied(false);
            }, 2000); // Reset after 2 seconds
            return () => clearTimeout(timer); // Cleanup timer on unmount or if copied again
        }
    }, [isTableCopied]);

    if (!businessAnalysisData) return null;

    return (
        <div className="space-y-6 overflow-y-auto -mb-12 ">
            <div className="w-full px-0 ">
                {/* <div className="mb-6">
        <h2 className="text-2xl font-medium text-zinc-100 mb-2">Business Transformation Analysis</h2>
        <p className="text-zinc-300">Current state to future state transformation journey</p>
    </div> */}
                <div className='  rounded-lg  '>
                    {/* Header Row */}
                    <div className="flex items-stretch gap-1 mb-0 mt-4 mx-8">
                        {/* Category Header */}
                        <div className="w-64  flex-shrink-0 p-4">
                            <div className="pl-6">
                            <h3 className="text-xl font-semibold text-gray-100">Category</h3>
                            <p className="text-sm text-gray-400">Transformation area</p>
                            </div>

                        </div>
                        {/* Current State Header */}
                        <div className="flex-1 p-4">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 bg-red-300/20 p-2 rounded-lg mr-4 mt-1.5">
                                    <img src="/util/app/b3-admin-story-current.svg" className="h-6 w-6" alt="Current State" />
                                </div>
                                <div>
                                    <h3 className="font-medium text-xl text-red-300">Current State</h3>
                                    <p className="text-sm text-gray-400">Existing pain points</p>
                                </div>
                            </div>
                        </div>
                        {/* Arrow Spacer */}
                        <div className="flex w-8 justify-center">
                            <div className="text-sky-500">
                                {/* <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg> */}
                            </div>
                        </div>
                        {/* Future State Header */}
                        <div className="flex-1 p-4">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 bg-sky-300/20 p-2 rounded-lg mr-4 mt-1.5">
                                    <img src="/util/app/b3-admin-story-transform-2.svg" className="h-6 w-6" alt="Transformation" />
                                </div>
                                <div>
                                    <h3 className="font-medium text-xl text-sky-300">Future State</h3>
                                    <p className="text-sm text-gray-400">What We Enable</p>
                                </div>
                            </div>
                        </div>
                        {/* Arrow Spacer */}
                        <div className="flex w-8 justify-center">
                            <div className="text-green-300">
                                {/* <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg> */}
                            </div>
                        </div>
                        {/* Business Impact Header */}
                        <div className="flex-1 p-4">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 bg-green-300/20 p-2 rounded-lg mr-4 mt-1.5">
                                    <img src="/util/app/b3-admin-story-future-3.svg" className="h-6 w-6" alt="Future State" />
                                </div>
                                <div>
                                    <h3 className="font-medium text-xl text-green-300">Business Impact</h3>
                                    <p className="text-sm text-gray-400">Expected benefits</p>
                                </div>
                            </div>
                        </div>
                        {/* StoryBite Button Spacer */}
                        {/* <div className="flex-none w-24 p-4"></div> */}
                        {/* Copy Button */}
                        <div className="flex-none w-48 p-2 pr-0 -mt-2">
                            <motion.button
                                onClick={() => {
                                    // Create HTML table for rich copying
                                    const htmlContent = `
                                        <table border="1" cellpadding="8" cellspacing="0" style="border-collapse: collapse; width: 100%;">
                                            <thead style="background-color: #333; color: white;">
                                                <tr>
                                                    <th>Category</th>
                                                    <th>Current State</th>
                                                    <th>Future State</th>
                                                    <th>Impact</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                ${businessTransformationResult?.transformationItems?.map(item => `
                                                    <tr>
                                                        <td><strong>${item.category}</strong></td>
                                                        <td>${item.from}</td>
                                                        <td>${item.to}</td>
                                                        <td>${item.impact || 'N/A'}</td>
                                                    </tr>
                                                `).join('')}
                                            </tbody>
                                        </table>
                                    `;
                                    
                                    // Create plain text version as fallback
                                    const textContent = 
                                        "Category\tCurrent State\tFuture State\tImpact\n" + 
                                        businessTransformationResult?.transformationItems?.map(item => 
                                            `${item.category}\t${item.from}\t${item.to}\t${item.impact || 'N/A'}`
                                        ).join('\n');
                                    
                                    // Use clipboard API for text copying
                                    navigator.clipboard.writeText(textContent)
                                        .then(() => {
                                            // Try to write HTML content if supported
                                            if (navigator.clipboard.write) {
                                                const blob = new Blob([htmlContent], {type: 'text/html'});
                                                const data = [new ClipboardItem({'text/html': blob})];
                                                navigator.clipboard.write(data).catch(err => 
                                                    console.error('HTML clipboard write failed:', err)
                                                );
                                            }
                                            setIsTableCopied(true);
                                        })
                                        .catch(err => {
                                            console.error('Failed to copy: ', err);
                                            setIsTableCopied(false);
                                        });
                                }}
                                className={`bg-zinc-800 w-36 text-white px-4 py-3 rounded-lg flex items-center gap-2 transition-colors duration-200 ${isTableCopied ? 'bg-zinc-400' : 'hover:bg-zinc-700'}`}
                                title="Copy as Markdown table"
                                whileHover={{ scale: 1.02 }}
                                whileTap={{ scale: 0.98 }}
                                transition={{ duration: 0.2 }}
                                disabled={isTableCopied}
                            >
                                {isTableCopied ? (
                                    <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                ) : (
                                    <img src="/util/app/b3-admin-copy.svg" alt="Copy" className="h-5 w-5" />
                                )}
                                <span className='text-sm ml-2'>{isTableCopied ? 'Copied!' : 'Copy Table'}</span>
                            </motion.button>
                        </div>
                    </div>

                    {/* Content Rows */}
                    <div className="overflow-y-auto max-h-[calc(100vh-16rem)] ">
                        {businessTransformationResult?.transformationItems?.map((item, index) => (
                            <div key={index}
                                className={`flex items-stretch text-normal gap-1 py-6 min-h-[120px] bg-blxxack/10   my-2 mx-8 rounded-lg
                                ${hoveredRowIndex === index ? 'bg-black/10 rounded-lg' : 
                                index % 2 === 0 ? ' ' : ' '}
                                ${index === 0 ? 'rounded-t-lg' : ''}
                                ${index === businessTransformationResult?.transformationItems.length - 1 ? 'rounded-b-lg mb-20' : ''}
                                `}>
                                {/* Category Column */}
                                <div className="w-64 flex-shrink-0 p-4 flex items-start">
                                    <div className="text-zinc-50 font-medium  text-normal  pl-4   w-full -ml-2">
                                        <span className="px-4 py-2 bg-zinc-800/20 text-sky-300 rounded-lg inline-block">
                                            {item.category}
                                        </span>

                                    </div>
                                </div>
                                <div className="flex-1 p-4 flex items-start">
                                    <div className="text-zinc-200 w-full">{item.from}</div>
                                </div>
                                <div className="flex   mt-6   w-8  justify-center">
                                    <svg
                                        className="w-6 h-6 text-sky-500"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 5l7 7-7 7"
                                        />
                                    </svg>
                                </div>
                                <div className="flex-1 p-4 flex items-start">
                                    <div className="text-zinc-200 w-full">{item.to}</div>
                                </div>
                                <div className="flex  w-8 mt-6  justify-center">
                                    <svg
                                        className="w-6 h-6 text-green-300"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 5l7 7-7 7"
                                        />
                                    </svg>
                                </div>
                                <div className="flex-1 p-4 flex items-start">
                                    <div className="text-zinc-200 w-full">{item.impact}</div>
                                </div>


                                <div className="flex-none w-24 p-4">
                                    <button
                                        onClick={() => handleGenerateStoryBite(item)}
                                        className="w-14 h-14 bg-black/20 hover:bg-sky-500 text-white rounded-full transition-colors flex items-center justify-center"
                                        onMouseEnter={() => setHoveredRowIndex(index)}
                                        onMouseLeave={() => setHoveredRowIndex(null)}
                                    >
                                        <img src="/util/app/b3-admin-conversation-2.svg" alt="Generate StoryBite" className="h-6" />
                                    </button>
                                </div>
                                <div className="flex-none w-24 p-4">
                                    <motion.button
                                        onClick={() => {
                                            handleCopy(item);
                                            // Animate confirmation
                                            animate("button", 
                                                { scale: [1, 1.1, 1] }, 
                                                { duration: 0.3 }
                                            );
                                        }}
                                            className="w-14 h-14 bg-black/20 hover:bg-sky-500 text-white rounded-full transition-colors flex items-center justify-center"
                                        onMouseEnter={() => setHoveredRowIndex(index)}
                                        onMouseLeave={() => setHoveredRowIndex(null)}
                                        whileTap={{ scale: 0.95 }}
                                        initial={{ scale: 1 }}
                                    >
                                        <img src="/util/app/b3-admin-copy.svg" alt="Copy" className="h-6 w-6" />
                                    </motion.button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* StoryBite Modal */}
                    {isModalOpen && (
                        <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center z-50">
                            <div className="bg-zinc-800 rounded-lg p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto">
                                <div className="flex justify-between items-center mb-4">
                                    <h3 className="text-xl font-base text-white">{storyBiteCategory} Story Bite</h3>
                                    <button
                                        onClick={() => setIsModalOpen(false)}
                                        className="text-gray-400 hover:text-white"
                                    >
                                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>

                                {isLoading ? (
                                    <div className="flex flex-col items-center justify-center py-10">
                                        {/* <div className="w-12 h-12 border-4 border-sky-500 border-t-transparent rounded-full animate-spin"></div> */}
                                        <RotateSpinner color="#38BDF8" className="mx-auto mb-12" size={48} />
                                        <p className="mt-4 text-gray-300">Generating StoryBite...</p>
                                    </div>
                                ) : (
                                    <div>
                                        <div className="bg-black/25 rounded-lg p-4 mb-4 whitespace-pre-line leading-8 text-gray-200">
                                            {/* {storyBite?.data?.shortStory} */}
                                            {storyBite?.data?.currentState}
                                        </div>
                                        <div className="bg-black/25 rounded-lg p-4 mb-4 whitespace-pre-line leading-8 text-gray-200">
                                            {storyBite?.data?.futureState}
                                        </div>
                                        <div className="bg-black/25 rounded-lg p-4 mb-4 whitespace-pre-line leading-8 text-gray-200">
                                            {storyBite?.data?.benefits}
                                        </div>
                                        <div className="flex justify-end">
                                            <button
                                                onClick={copyToClipboard}
                                                className="px-4 py-2 bg-sky-600 hover:bg-sky-700 text-white rounded-md transition-colors flex items-center"
                                            >
                                                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                                                </svg>
                                                Copy to Clipboard
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>

                        </div>
                    )}

                    {(!businessTransformationResult?.transformationItems || businessTransformationResult.transformationItems.length === 0) && (
                        <div className="text-center py-8 text-gray-400">
                            No transformation data available
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PathProductBusinessTransformation;